module.exports = __webpack_public_path__ + "static/media/SKHU_slogen_hu.43cb56a8.png";